<template>
  <v-app >

    <template v-if="!$route.meta.public">
  

        <component v-bind:is="layout"></component>

   
  
    </template>
    <template v-else>
      <sequential-entrance>
        <router-view></router-view>
      </sequential-entrance>
    </template>
  </v-app>
</template>

<script>
  import {
    PerfectScrollbar
  } from "vue2-perfect-scrollbar";
  import LayoutHorizontal from './layouts/LayoutHorizontal'
  import LayoutMini from './layouts/LayoutMini'
  import LayoutVertical from './layouts/LayoutVertical'

  export default {
    name: 'App',
    components: {
  PerfectScrollbar,
     
      'layout-mini': LayoutMini,
      'layout-horizontal': LayoutHorizontal,
      'layout-vertical': LayoutVertical
    },
    data: () => ({
      //
    }),
    computed: {
      layout() {
        return this.$store.state.layout;
      }
    }
  }
</script>
<style>
*, ::before, ::after {
     background-repeat:repeat;
    box-sizing: inherit;
}

.v-application {
    display: flex;
    position: relative;
  
}
.v-application--wrap {
    flex: 1 1 auto;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    max-width: 100%;
    position: relative;
    overflow-x:hidden;
    overflow-y:hidden;
}
.ps{
  height:100%;
}
</style>